import type { Product, ProductCategory } from "@app-types/index";

export const productCategories: ProductCategory[] = [
  "Automotor",
  "Riesgos Varios",
  "Vida y Salud",
  "Empresarial",
];

export const products: Product[] = [
  {
    slug: "automotor",
    category: "Automotor",
    audience: "ambos",
    name: "Automotor",
    short: "Autos, motos y vehículos comerciales.",
    description:
      "Coberturas que se adaptan al uso real de tu vehículo, con asistencia 24/7 y atención de siniestros con productor dedicado.",
    icon: "car",
    highlights: [
      "Responsabilidad civil hasta todo riesgo",
      "Cobertura para autos 0km y usados",
      "Asistencia mecánica y grúa 24/7",
    ],
    popular: true,
  },
  {
    slug: "hogar",
    category: "Riesgos Varios",
    audience: "personas",
    name: "Hogar",
    short: "Tu casa, tu contenido y tu familia.",
    description:
      "Robo, incendio, daños por agua, electrónicos y responsabilidad civil familiar en un solo plan.",
    icon: "home",
    highlights: [
      "Edificio y contenido",
      "Asistencia al hogar",
      "Daños por terceros",
    ],
    popular: true,
  },
  {
    slug: "vida",
    category: "Vida y Salud",
    audience: "ambos",
    name: "Vida",
    short: "Tranquilidad para los tuyos.",
    description:
      "Coberturas individuales y colectivas con primas a medida, sin trámites engorrosos.",
    icon: "heart",
    highlights: [
      "Vida individual y colectiva",
      "Capital por fallecimiento",
      "Renta por incapacidad",
    ],
  },
  {
    slug: "comercio",
    category: "Empresarial",
    audience: "empresas",
    name: "Comercio",
    short: "Pymes, locales y oficinas.",
    description:
      "Integral de comercio adaptado a rubro y facturación: stock, cristales, robo y RC.",
    icon: "store",
    highlights: [
      "Stock y mercadería",
      "Cristales y carteles",
      "Responsabilidad civil comercial",
    ],
    popular: true,
  },
  {
    slug: "art",
    category: "Empresarial",
    audience: "empresas",
    name: "ART",
    short: "Aseguradora de Riesgos del Trabajo.",
    description:
      "Cumplimiento normativo con asesoría en prevención y atención inmediata al trabajador.",
    icon: "hardhat",
    highlights: [
      "Cobertura legal completa",
      "Prevención y capacitaciones",
      "Atención del siniestro laboral",
    ],
  },
  {
    slug: "accidentes-personales",
    category: "Vida y Salud",
    audience: "ambos",
    name: "Accidentes Personales",
    short: "Cobertura 24 horas, en cualquier lugar.",
    description:
      "Para deportistas, profesionales y staff de empresas. Indemnización por accidente o fallecimiento.",
    icon: "shield",
    highlights: [
      "Cobertura 24/7",
      "Asistencia médica",
      "Indemnización por incapacidad",
    ],
  },
  {
    slug: "caucion",
    category: "Empresarial",
    audience: "empresas",
    name: "Caución",
    short: "Garantías para licitaciones y contratos.",
    description:
      "Pólizas de caución para alquileres, obras públicas y privadas, y operaciones aduaneras.",
    icon: "document",
    highlights: [
      "Alquiler de inmuebles",
      "Obra pública y privada",
      "Aduanera",
    ],
  },
  {
    slug: "transporte",
    category: "Riesgos Varios",
    audience: "empresas",
    name: "Transporte",
    short: "Mercaderías en tránsito.",
    description:
      "Cobertura de mercaderías por carretera, aérea y marítima, con opciones por viaje o anual.",
    icon: "truck",
    highlights: ["Nacional e internacional", "Por viaje o anual", "Multimodal"],
  },
  {
    slug: "embarcacion",
    category: "Riesgos Varios",
    audience: "ambos",
    name: "Embarcación",
    short: "Náutica deportiva y comercial.",
    description:
      "Casco, motor, responsabilidad civil y asistencia náutica para tu embarcación.",
    icon: "boat",
    highlights: ["Casco y motor", "RC náutica", "Asistencia en agua"],
  },
];

export function productsByCategory() {
  return products.reduce<Record<string, Product[]>>((acc, product) => {
    (acc[product.category] ??= []).push(product);
    return acc;
  }, {});
}
